/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = exports.PrivacyPolicyType = exports.CornerRadius = exports.ButtonPosition = exports.Audience = void 0;
var Audience;
(function (Audience) {
    Audience["unknown_audience"] = "unknown_audience";
    Audience["all_visitors"] = "all_visitors";
    Audience["eu_visitors"] = "eu_visitors";
})(Audience = exports.Audience || (exports.Audience = {}));
var ButtonPosition;
(function (ButtonPosition) {
    ButtonPosition["unknown_button_position"] = "unknown_button_position";
    ButtonPosition["bottom_right"] = "bottom_right";
    ButtonPosition["bottom_left"] = "bottom_left";
    ButtonPosition["center_right"] = "center_right";
    ButtonPosition["center_left"] = "center_left";
})(ButtonPosition = exports.ButtonPosition || (exports.ButtonPosition = {}));
var CornerRadius;
(function (CornerRadius) {
    CornerRadius["unknown_corner_radius"] = "unknown_corner_radius";
    CornerRadius["square"] = "square";
    CornerRadius["rounded_corners"] = "rounded_corners";
    CornerRadius["round"] = "round";
})(CornerRadius = exports.CornerRadius || (exports.CornerRadius = {}));
var PrivacyPolicyType;
(function (PrivacyPolicyType) {
    PrivacyPolicyType["unknown_privacy_policy_type"] = "unknown_privacy_policy_type";
    PrivacyPolicyType["page_on_site"] = "page_on_site";
    PrivacyPolicyType["external_url"] = "external_url";
})(PrivacyPolicyType = exports.PrivacyPolicyType || (exports.PrivacyPolicyType = {}));
var Theme;
(function (Theme) {
    Theme["unknown_theme"] = "unknown_theme";
    Theme["light"] = "light";
    Theme["dark"] = "dark";
    Theme["custom"] = "custom";
})(Theme = exports.Theme || (exports.Theme = {}));
//# sourceMappingURL=types.js.map